import { Link } from "react-router-dom";
import { SITE_NAME } from "@/hooks/useSeo";

const columns = [
  {
    title: "栏目",
    links: [
      { to: "/ranking", label: "打榜观察" },
      { to: "/ranking?category=票数分析", label: "票数分析" },
      { to: "/ranking?category=粉丝生态", label: "粉丝生态" },
      { to: "/ranking?category=赛事规则", label: "赛事规则" },
    ],
  },
  {
    title: "精选内容",
    links: [
      { to: "/article/midnight-vote-spike", label: "凌晨票数跳涨复盘" },
      { to: "/article/five-inflation-tricks", label: "五种注水手法" },
      { to: "/article/cost-of-one-vote", label: "打榜成本调查" },
      { to: "/article/fundraising-ledger", label: "集资账本疑云" },
    ],
  },
  {
    title: "关于",
    links: [
      { to: "/about", label: "关于我们" },
      { to: "/about#principles", label: "内容原则" },
      { to: "/about#voices", label: "读者口碑" },
      { to: "/about#contact", label: "联系方式" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="bg-primary-900 text-primary-100 mt-auto">
      <div className="px-4 md:px-6 xl:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:pr-8">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-vip-crown-2-line text-lg" />
              </span>
              <span className="font-heading text-lg font-bold text-background-50">{SITE_NAME}</span>
            </div>
            <p className="text-sm leading-relaxed text-primary-200">
              围观选美吃瓜的投票打榜环节，记录票数异常、粉丝拉票与排名争议，帮你在热搜之外多看一层。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a
                href="mailto:editor@guaguan-microscope.example.com"
                rel="nofollow"
                aria-label="邮件联系编辑部"
                className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-800 text-primary-100 hover:bg-primary-700 transition-colors cursor-pointer"
              >
                <i className="ri-mail-line" />
              </a>
              <Link
                to="/ranking"
                aria-label="前往打榜观察栏目"
                className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-800 text-primary-100 hover:bg-primary-700 transition-colors cursor-pointer"
              >
                <i className="ri-radar-line" />
              </Link>
              <Link
                to="/about#subscribe"
                aria-label="订阅吃瓜日报"
                className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-800 text-primary-100 hover:bg-primary-700 transition-colors cursor-pointer"
              >
                <i className="ri-notification-3-line" />
              </Link>
            </div>
          </div>

          {columns.map((col) => (
            <nav key={col.title} aria-label={col.title}>
              <h4 className="font-heading text-base font-bold text-background-50 mb-4">{col.title}</h4>
              <ul className="flex flex-col gap-2.5">
                {col.links.map((link) => (
                  <li key={link.to + link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-primary-200 hover:text-background-50 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-primary-700 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-primary-300">
          <p>© 2026 {SITE_NAME} · 内容仅代表编辑部观察，不针对任何具体个人与机构。</p>
          <p>联系方式：editor@guaguan-microscope.example.com</p>
        </div>
      </div>
    </footer>
  );
}